import React, { useEffect, useState } from "react";
import { useWeightContext } from "../context/appContext";
import ContainerWithTitle from "../../../containers/title.container";
import CheckboxInput from "../../../containers/input.checkbox";
import ButtonContainer from "../../../containers/button";

const predefinedConditions = [
  "Diet Plans",
  "Gym / Exercise",
  "Supplements",
  "Ayurvedic or Home remedies",
  "Nothing Seriously yet",
];

const QuestionFourteen = ({ onNext, onPrev }) => {
  const { payload, setPayload, currentPage, setCurrentPage, setErrorMessage } =
    useWeightContext();
  const [value, setValue] = useState([]);
  const [isOtherChecked, setIsOtherChecked] = useState(false);
  const [otherValue, setOtherValue] = useState("");

  useEffect(() => {
    const conditions = payload?.diagnosed_conditions || [];
    const knownConditions = conditions.filter((condition) =>
      predefinedConditions.includes(condition)
    );
    const unknownConditions = conditions.filter(
      (condition) => !predefinedConditions.includes(condition)
    );

    setValue(knownConditions);

    if (unknownConditions.length > 0) {
      setOtherValue(unknownConditions[0]);
      setIsOtherChecked(true);
    }
  }, [currentPage, payload]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isOtherChecked === true) {
      if (otherValue.trim() === "") {
        setErrorMessage("Please provide a value for 'Others'");
        return;
      } else {
        return onNext([...value, otherValue]);
      }
    }

    if (value.length > 0) {
      // window.gtag({
      //   event: "user_already_tried",
      //   data: {
      //     already_tried: value,
      //   },
      // });
      onNext(value);
    } else {
      setErrorMessage("Please select at least one.");
    }
  };

  const handleCheckboxChange = (event) => {
    const { value: checkboxValue, checked } = event.target;
    if (checked) {
      window.gtag({
        event: "user_already_tried",
        data: {
          already_tried: [...value, checkboxValue],
        },
      });
      if (window.fbq) {
        window.fbq("track", "user_already_tried", {
          already_tried: [...value, checkboxValue],
        });
      }
      setValue([...value, checkboxValue]);
    } else {
      setValue(value.filter((symptom) => symptom !== checkboxValue));
    }
  };

  const handleOtherCheckboxChange = (event) => {
    const { checked } = event.target;
    if (checked) {
      setIsOtherChecked(true);
    } else {
      setIsOtherChecked(false);
      setOtherValue("");
    }
  };

  const handleOtherInputChange = (e) => {
    setErrorMessage(null);
    setOtherValue(e.target.value);
  };

  return (
    <ContainerWithTitle
      title="Have you tried anything before for weight/fat loss?"
      handleBack={onPrev}
      handleNext={handleSubmit}
      isContinueButton={value.length > 0 ? true : otherValue ? true : false}
    >
      <ul>
        {predefinedConditions.map((condition) => (
          <CheckboxInput
            key={condition}
            label={condition}
            value={condition}
            checked={value.includes(condition)}
            onChange={handleCheckboxChange}
          />
        ))}
        {/* <CheckboxInput
          label="Others"
          value=""
          checked={isOtherChecked}
          onChange={handleOtherCheckboxChange}
        />
        {isOtherChecked && (
          <input
            type="text"
            placeholder="Please specify"
            value={otherValue}
            className="input mt-5"
            onChange={handleOtherInputChange}
          />
        )} */}
      </ul>
      {/* <ButtonContainer onClick={handleSubmit}>Next</ButtonContainer> */}
    </ContainerWithTitle>
  );
};

export default QuestionFourteen;
